module.exports = __webpack_public_path__ + "static/media/baks.fd84bc36.png";